import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { GlobalFilterBar } from "./GlobalFilterBar";

export function AppShell() {
  const [filterOpen, setFilterOpen] = useState(false);

  return (
    <div className="min-h-screen bg-surface-muted">
      <Sidebar />
      <div className="ml-64 flex flex-col min-h-screen">
        <Topbar
          onFilterToggle={() => setFilterOpen((o) => !o)}
          filterOpen={filterOpen}
        />
        <main className="flex-1 pt-16 overflow-x-hidden">
          <GlobalFilterBar open={filterOpen} />
          <div className="px-6 py-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
